import { Route, Routes } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { lazyPage } from '@/lib/lazy-load'
import { BrandKitProvider } from '@/context/BrandKitContext'
import { useOrgPerm } from '@/hooks/useOrgPerm'
import { BRAND_KIT_ID_PARAM } from '@/shared/constants'
import { WrapperProps } from '@/shared/routes'
import Layout from '@/components/Layout'
import { PageUnauthorized } from '@/components/PageUnauthorized'

const BrandKitIndexPage = lazyPage(() => import('./index/BrandKitIndexPage'))
const BrandKitDetailPage = lazyPage(() => import('./detail/BrandKitDetailPage'))

/**
 * Org brand kit routes
 */
const brandKitRoutes = [
  {
    name: 'Brand Kits',
    index: true,
    component: BrandKitIndexPage,
  },
  {
    path: `${BRAND_KIT_ID_PARAM}/*`,
    name: 'Brand Kits',
    component: BrandKitDetailPage,
    showOnNav: false,
  },
]

/**
 * Brand kit routes wrapper
 */
export default function OrgBrandKitRoutes({ title }: WrapperProps) {
  const canViewListApp = useOrgPerm(OrgPermission.AppsViewListOfApps)

  if (!canViewListApp) {
    return (
      <Layout title={title}>
        <PageUnauthorized />
      </Layout>
    )
  }

  return (
    <BrandKitProvider>
      <Routes>
        {brandKitRoutes.map(({ component: Comp, ...rest }) => {
          return (
            <Route
              key={`bk-${rest.path || 'index'}`}
              index={rest.index}
              path={rest.index ? undefined : rest.path}
              element={<Comp title={rest.name} />}
            />
          )
        })}
      </Routes>
    </BrandKitProvider>
  )
}
